var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "regulation-form" },
    [
      _c(
        "panel-competition-form-box",
        { staticClass: "regulation-form__box mab16" },
        [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8" },
            [
              _c("p", { staticClass: "form-input__label" }, [
                _vm._v("Regulamin zawodów"),
              ]),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "statuteType",
                  option: { value: "file", title: "Wgraj plik" },
                },
                model: {
                  value: _vm.form.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "type", $$v)
                  },
                  expression: "form.type",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "regulation-form__nested",
                  class: {
                    "regulation-form__nested--disabled":
                      _vm.form.type !== "file",
                  },
                },
                [
                  _c("base-input-file", {
                    attrs: {
                      "is-multiple": false,
                      accept: ".pdf",
                      converter: "base64",
                      hint: "Wybierz plik",
                      disabled: _vm.form.type !== "file",
                    },
                    model: {
                      value: _vm.form.file,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "file", $$v)
                      },
                      expression: "form.file",
                    },
                  }),
                  _vm.showFileCurrent
                    ? _c(
                        "div",
                        { staticClass: "regulation-form__file-current mat16" },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.previewHref,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentFileName))]
                          ),
                          _c(
                            "div",
                            { staticClass: "mat8" },
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    btn2: "",
                                    short: "",
                                    loading: _vm.removing,
                                    disabled: _vm.saving || _vm.removing,
                                  },
                                  on: { click: _vm.onRemove },
                                },
                                [_vm._v(" Usuń plik ")]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("panel-input-base-radio", {
                attrs: {
                  name: "statuteType",
                  option: { value: "link", title: "Regulamin pod linkiem" },
                },
                model: {
                  value: _vm.form.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "type", $$v)
                  },
                  expression: "form.type",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "regulation-form__nested",
                  class: {
                    "regulation-form__nested--disabled":
                      _vm.form.type !== "link",
                  },
                },
                [
                  _c("panel-input-text", {
                    attrs: { hint: "http://" },
                    model: {
                      value: _vm.form.link,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "link", $$v)
                      },
                      expression: "form.link",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "col-12 col-lg-4" }, [
            _c("p", { staticClass: "form-input__hint" }, [
              _vm._v(
                " Dodaj regulamin w pliku PDF lub podaj link do regulaminu na zewnętrznej stronie. "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                " Link może prowadzić do strony html lub bezpośrednio do pliku z regulaminem. "
              ),
              _c("br"),
              _c("br"),
              _vm._v(" Maksymalny rozmiar pliku: 2,5 MB (PDF). "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "regulation-form__actions mat24 mab24" },
        [
          _c(
            "base-button",
            {
              attrs: {
                btn1: "",
                loading: _vm.saving,
                disabled: _vm.saving || _vm.removing,
              },
              on: { click: _vm.onSave },
            },
            [_vm._v("Zapisz")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }